var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dynamic-tags__section" }, [
    _c("div", { staticClass: "tags" }, [
      _c(
        "section",
        { class: _vm.tagClass },
        _vm._l(_vm.dynamicTags, function (tag, index) {
          return _c(
            "div",
            { key: index, style: _vm.tagStyle },
            [
              _c(
                "el-tooltip",
                {
                  class: { "tag-with-tooltip": !!tag.instruction },
                  attrs: {
                    placement: "top",
                    effect: "light",
                    disabled: !tag.instruction,
                  },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    tag.instruction
                      ? _c("section", {
                          staticStyle: { "word-break": "normal" },
                          domProps: { innerHTML: _vm._s(tag.instruction) },
                        })
                      : _c("div", [
                          _vm._v("\n              N/A\n            "),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("el-alert", {
                    staticClass: "device-dynamic-tag",
                    staticStyle: { "word-break": "normal" },
                    attrs: { title: tag.name, type: "error", closable: false },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }